import CloseCross from "@/assetsV2/CloseCross";
import PickWalletAccordion from "../Accordion/PickWallet";
import PickGccAccordion from "../Accordion/PickGcc";
import useSolanaTransaction from "@/callbacks/useSolanaTransaction";
import ErrorWarningIcon from "@/assetsV3/ErrorWarning";
import SolanaIcon from "@/assetsV2/Marketplace/SolanaIcon";
import { IGCCHoldings } from "@/types/IGCCHoldings";
import MyTooltip from "@/components/Common/MyTooltip";
import InfoIcon from "@/assetsV3/profile/Info";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

type Props = {
  selectedWallet: string;
  setSelectedWallet: (val: string) => void;
  setSelectedGcc: (val: IGCCHoldings) => void;
  selectedGcc: IGCCHoldings | undefined;
  setShowModal: (val: boolean) => void;
  displayAmount: string;
  setDisplayAmount: (val: string) => void;
  displayPrice: string;
  setDisplayPrice: (val: string) => void;
  isEnableWalletSelection: boolean;
  gasFee: number;
  solBalance: number;
  gasFeeLoader: boolean;
};

export function WebOfferListForm({
  selectedWallet,
  setSelectedWallet,
  setSelectedGcc,
  selectedGcc,
  setShowModal,
  displayAmount,
  setDisplayAmount,
  displayPrice,
  setDisplayPrice,
  isEnableWalletSelection,
  gasFee,
  solBalance,
  gasFeeLoader
}: Props) {
  const { fromLamports } = useSolanaTransaction();
  const remainingAmount = selectedGcc
    ? fromLamports(selectedGcc.tokens) -
    fromLamports(selectedGcc.tokens_onmarket)
    : 0;
  return (
    <div className="flex flex-col hidden outmd:flex">
      <div className="flex flex-col p-6 gap-6 w-full bg-outbackground-main opacity-100 rounded-none outmd:rounded-2xl">
        <div
          className="cursor-pointer justify-end hidden outmd:flex"
          onClick={() => {
            setShowModal(false);
          }}
        >
          <CloseCross className="fill-outicon-sub h-[30px] w-[30px]" />
        </div>
        <div className="flex justify-between items-center">
          <p className="text-[21px] leading-[29.4px] text-outext-main font-bold hidden outmd:flex">
            Listing
          </p>
        </div>
        <div className="flex flex-col gap-6 hidden outmd:flex">
          <div className="flex flex-col gap-1">
            <div className="flex gap-px text-[15px] font-bold tracking-normal leading-5 whitespace-nowrap">
              <div className="text-outext-main text-[15px] font-bold ">
                Wallet
              </div>
            </div>
            <PickWalletAccordion
              selectedWallet={selectedWallet}
              setSelectedWallet={setSelectedWallet}
              isEnableWalletSelection={isEnableWalletSelection}
              isListedScreen={true}
            />
          </div>
          <div className="flex flex-col  gap-1">
            <div className="flex gap-px text-[15px] font-bold tracking-normal leading-5 whitespace-nowrap">
              <div className="text-outext-main text-[15px] font-bold ">
                Chip
              </div>
            </div>
            <PickGccAccordion
              setSelectedGcc={setSelectedGcc}
              selectedGcc={selectedGcc}
              isEnableWalletSelection={isEnableWalletSelection}
            />
          </div>
          <div className="flex flex-col relative  gap-1">
            <div className="flex gap-px text-[15px] font-bold tracking-normal leading-5 whitespace-nowrap">
              <div className="text-outext-main text-[15px] font-bold ">
                Chip Amount
              </div>
            </div>
            <div
              className={`flex h-[46px] justify-between border border-outstate-grayborder text-sm leading-5 rounded-lg focus:bg-outbackground-weak bg-outbackground-main focus:ring-transparent px-[18px] py-3 block w-full !outline-none text-outext-soft`}
            >
              <input
                type="number"
                className={
                  "bg-transparent placeholder:text-outext-sub font-medium placeholder:font-medium text-sm placeholder:text-sm text-outext-main border-none outline-none focus:border-none focus:outline-none"
                }
                value={displayAmount}
                onChange={(e) => {
                  // Only allow integers
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) {
                    setDisplayAmount(value);
                  }
                }}
                placeholder="Enter Amount"
                step="1" // Disallows decimals
              />
              {selectedGcc && +displayAmount >= remainingAmount ? (
                <></>
              ) : (
                // <></>
                <button
                  onClick={() => {
                    if (selectedGcc) {
                      setDisplayAmount(remainingAmount.toString());
                    }
                  }}
                >
                  <span className="text-outext-blue text-base font-medium">Max</span>
                </button>
              )}
            </div>
            <div
              className={`flex absolute -bottom-1 sm:bottom-[-20px] gap-1 py-0.5 mt-1 text-xs leading-4 text-outstate-error ${selectedGcc && +displayAmount > remainingAmount
                ? ""
                : "opacity-0"
                }`}
            >
              {selectedGcc ? (
                remainingAmount === 0 ? (
                  <div className="flex-1">
                    Insufficient Amount
                  </div>
                ) : (
                  <div className="flex-1">
                    You own {remainingAmount} {remainingAmount === 1 ? 'Chip' : 'Chips'} only
                  </div>
                )
              ) : (
                <span>Error in amount</span>
              )}
            </div>
          </div>
          <div className="flex flex-col gap-1">
            <div className="flex gap-px text-[15px] font-bold tracking-normal leading-5 whitespace-nowrap">
              <div className="text-outext-main">Price Per Chip</div>
            </div>
            <div
              className={`border flex border-outstate-grayborder text-sm leading-5 rounded-lg focus:bg-outbackground-weak bg-outbackground-main focus:ring-transparent px-[18px] py-3 w-full !outline-none text-outext-soft`}
            >
              <input
                type="number"
                className={
                  "bg-transparent flex-1 text-sm placeholder:text-outext-sub font-medium placeholder:font-medium  placeholder:text-sm text-outext-main border-none outline-none focus:border-none focus:outline-none"
                }
                value={displayPrice === "" ? "" : +displayPrice}
                onChange={(e) => {
                  if (e.target.value !== "") {
                    setDisplayPrice(Number(e.target.value).toString());
                  } else {
                    setDisplayPrice("");
                  }
                }}
                placeholder="Enter Price"
              />
              <SolanaIcon className={+displayPrice <= 0 ? "fill-outext-sub" : 'fill-outext-main'} />
            </div>
          </div>
          <div className="flex font-normal font-inter justify-between">
            <p className="text-base text-outext-main">Estimated Fee</p>
            <div className="flex gap-1 items-center">
              <SolanaIcon className="fill-outstate-whitecompact" />
              {
                gasFeeLoader
                  ?
                  <span className="mt-[-4px]">
                    <SkeletonTheme baseColor="#373737" highlightColor="#C0C0C0">
                      <div className="flex flex-row items-center gap-6">
                        <Skeleton height={20} width={100} style={{ borderRadius: '8px' }} />
                      </div>
                    </SkeletonTheme>
                  </span>
                  :
                  <span className="text-base text-outext-main">{gasFee}</span>
              }
            </div>
          </div>
          <div className="flex justify-between">
            <p className="text-base text-outext-main flex gap-1 justify-start items-start">Total
              <MyTooltip message="A 7% fee divided equally between creators will be deducted once sold">
                <InfoIcon width={"10px"} height={"10px"} className="fill-outext-main" />
              </MyTooltip>
            </p>
            <div className="flex gap-1 items-center">
              <SolanaIcon className={`${(gasFee > solBalance) && selectedWallet ? "fill-outred-base" : "fill-outstate-whitecompact"}`} />
              {
                gasFeeLoader
                  ?
                  <span className="mt-[-4px]">
                    <SkeletonTheme baseColor="#373737" highlightColor="#C0C0C0">
                      <div className="flex flex-row items-center gap-6">
                        <Skeleton height={20} width={100} style={{ borderRadius: '8px' }} />
                      </div>
                    </SkeletonTheme>
                  </span>
                  :
                  <span className={`text-base ${(gasFee > solBalance) && selectedWallet ? "text-outred-base" : "text-outext-main"}`}>
                    {(gasFee)}
                  </span>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
